<template>
  <div>
    <p class="field">
      <label for="languageselectlist" v-translate>Jazyk překladu</label>
      <select
          :key="id+'languageselectlist'"
          :id="id+'languageselectlist'"
          :name="id+'languageselectlist'"
          ref="translationlanguageselectorref"
          v-model="language"
      >
        <option
            v-for="language in languageOptions"
            :key="language.value"
            :value="language.value"
        >
          {{ language.text }}
        </option>
      </select>
    </p>
    <div class="language_selector">
      <a v-if="isEditable"
         class="btn btn_grey btn_dropdown"
         :class="{ 'active': isAddLanguageOpen }"
         :title="'Jazyky' | translate"
         v-translate
         @click="openLanguageSelect"
      >Jazyky</a>
      <div class="dropdown_content" :class="{ 'open': isAddLanguageOpen }">
        <ul>
          <li v-for="language in allowedLanguages">
            <input type="checkbox"
                   :id="id+'-select-language-'+language.value"
                   :key="id+'-select-language-'+language.value"
                   :value="false"
                   :disabled="!isEditable"
                   v-model="selectedLanguages[language.value]"
            >
            <label :for="id+'-select-language-'+language.value">
              {{ language.text }}
            </label>
          </li>
        </ul>
        <p class="field">
          <input
              :class="{'btn_grey': !isEditable}"
              class="btn"
              type="submit"
              :disabled="!isEditable"
              :key="id+'-save-language'"
              :value="'Uložit' | translate" @click.prevent="onSelectLanguages">
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "AdvertisingBannerNewSettings",
  components: {},
  props: {
    id: {
      type: String,
      Default: "langSelector"
    },
    isEditable: Boolean,
    allowedLanguages: Array,
    selectedLanguages: Object,
  },
  data() {
    return {
      isAddLanguageOpen: false,
      languageOptions: [],
      selectedLanguage: null,
      language: null,
    };
  },
  created() {
    this.setLanguageOptions();
    this.setDefaultLanguage();
    this.onLanguageChange();
  },
  methods: {
    openLanguageSelect(){
      this.isAddLanguageOpen = true;
    },
    onSelectLanguages() {
      this.isAddLanguageOpen = false;
      this.setLanguageOptions();
      this.setDefaultLanguage();
      this.$emit('onLanguageListSelectionChange', this.getSelectedLanguageList());
    },
    onLanguageChange(){
      this.$emit('input', this.selectedLanguage, this.getSelectedLanguageList());
    },
    getSelectedLanguageList(){
      let languages = [];
      Object.keys(this.selectedLanguages).forEach(key => {
        if(this.selectedLanguages[key]){
          languages.push(key);
        }
      });

      return languages;
    },
    setDefaultLanguage(){
      if(!this.selectedLanguages.hasOwnProperty(this.selectedLanguage) || !this.selectedLanguages[this.selectedLanguage]){
        if(this.languageOptions.length > 0){
          this.language = this.languageOptions[0].value;
        }else{
          this.language = null;
        }
      }
    },
    setLanguageOptions(){
      let options = [];
      Object.keys(this.selectedLanguages).forEach(key => {
        if(this.selectedLanguages[key]){
          options.push({value: key, text: key.toUpperCase()});
        }
      })
      this.languageOptions = options;
    },
    preselectLanguages(languages){
      let options = [];
      languages.forEach(item => {
        options.push({value: item, text: item.toUpperCase()})
      });
      this.languageOptions = options;
    }
  },
  watch: {
    language(newVal){
      this.selectedLanguage = newVal;
      this.onLanguageChange();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/TranslationLanguageSelector.vue